'use client'

import { PropsWithChildren } from 'react'
import { MarketplaceCartProvider } from '@domain/marketplace/cart/MarketplaceCartContext'
import { MarketplaceFavoritesProvider } from '@domain/marketplace/favorites/MarketplaceFavoritesContext'

/**
 * Scoped marketplace cart/favorites context for layouts that render Header
 * (cart button, favorites, drawers). Kept out of root App.tsx to avoid loading
 * marketplace API hooks on routes without header chrome (e.g. /sso).
 */
export function MarketplaceProviders({ children }: PropsWithChildren) {
  return (
    <MarketplaceFavoritesProvider>
      <MarketplaceCartProvider>{children}</MarketplaceCartProvider>
    </MarketplaceFavoritesProvider>
  )
}
